export const ROLES = {
  ADMIN: "ADMIN",
  CLIENT: "CLIENT",
};

export const BOOKING_STATUS = {
  CONFIRMED: "CONFIRMED",
  CANCELED: "CANCELED",
  COMPLETED: "COMPLETED",
};

export const BOOKING_OWNER_TYPE = {
  USER: "USER",
  GUEST: "GUEST",
};

export const SERVICE_MODE = {
  STUDIO: "STUDIO",
  MOBILE: "MOBILE",
};

export const FILE_CATEGORIES = {
  IMAGES: "images",
  VIDEOS: "videos",
  DOCS: "docs",
};

export const TIME_SLOT_INTERVAL_MINUTES = 15;

export const DEFAULT_API_ERROR_MESSAGE =
  "Something went wrong. Please try again.";

export const APP_NAME = "Nayra Henna";

export const STUDIO_MODE_DESCRIPTION =
  "A studio appointment means you will visit the artist for your service.";

export const MOBILE_MODE_DESCRIPTION =
  "A mobile appointment means the artist will travel to your location for the service.";

export const LOCATION_NOTES_DESCRIPTION =
  "Location notes help the artist arrive smoothly by sharing the correct address details, entry instructions, gate codes, apartment numbers, parking information, or nearby landmarks.";

export const AUTO_MOBILE_PARTY_SIZE_THRESHOLD = 4;

export const MOBILE_TRAVEL_EXPENSES_DISCLAIMER =
  "For bookings with a party size of 4 or more, the appointment is automatically set to mobile, and the client is responsible for the artist’s travel expenses.";

export const HENNA_TYPES = {
  JAGUAR: "Jaguar",
  RED_NATURAL: "Red Natural Henna",
  BLACK_NATURAL: "Black Natural Henna",
  RED_CHERRY: "Red/Cherry",
};

export const HENNA_TYPE_OPTIONS = [
  HENNA_TYPES.JAGUAR,
  HENNA_TYPES.RED_NATURAL,
  HENNA_TYPES.BLACK_NATURAL,
  HENNA_TYPES.RED_CHERRY,
];

export const JAGUAR_HENNA_EXTRA_PRICE = 25;

export const JAGUAR_HENNA_DISCLAIMER =
  "Jaguar henna adds $25 to the booking total and should be requested at least two weeks before the appointment.";